<script>
  import rosterStore from "./player-store.js";
  import { onMount, onDestroy } from "svelte";
  import PlayerFilter from "./PlayerFilter.svelte";
  import PlayerCard from "./PlayerCard.svelte";
  import AddPlayer from "./AddPlayer.svelte";

  // import { scale, fade, fly, slide } from "svelte/transition";
  // import { flip } from "svelte/animate";
  // import { elasticIn } from "svelte/easing";

  let selfieCardData = null;
  let selfieCard = null;
  let selfie = null;
  let addPlayerMode = false;
  let players;

  const unsubscribe = rosterStore.subscribe(items => {
    players = items;
  });

  onMount(() => {
    selfieCardData = window.localStorage.getItem("selfieCard");
    selfieCard = JSON.parse(selfieCardData);
  });

  onDestroy(() => {
    if (unsubscribe) {
      unsubscribe();
    }
  });

  let filter = "ALL";
  let filteredPlayers = null;

  $: if (filter === "ALL") {
    filteredPlayers = players;
  } else if (filter === "FAV") {
    filteredPlayers = players.filter(p => p.isFavorite === true);
  } else {
    filteredPlayers = players.filter(p => p.position.code === filter);
  }

  function setFilter(event) {
    // adding selfie player card
    if (event.detail === "ADD") {
      addPlayerMode = true;
    } else {
      filter = event.detail;
    }
  }

  function addPlayer(event) {
    addPlayerMode = false;
    selfieCard = event.detail;
  }

  function cancelAdd() {
    addPlayerMode = false;
  }

  // https://stackoverflow.com/questions/17710147/image-convert-to-base64#answer-17711190
  function readFile() {
    if (this.files && this.files[0]) {
      let FR = new FileReader();

      FR.addEventListener("load", function(e) {
        selfie = e.target.result;
      });

      FR.readAsDataURL(this.files[0]);
    }
  }
</script>

<style lang="scss">
  @import "../style/theme-config.scss";

  .card-grid {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 4rem;
    justify-content: center;

    @media (min-width: 768px) {
      grid-template-columns: repeat(auto-fill, 313px);
    }

    @media (min-width: 992px) {
      grid-template-columns: repeat(auto-fill, 267px);
    }

    @media (min-width: 1200px) {
      grid-template-columns: repeat(auto-fill, 327px);
    }
  }
</style>

<PlayerFilter on:click={setFilter} />

{#if addPlayerMode}
  <AddPlayer on:add={addPlayer} on:cancel={cancelAdd} />
{/if}

{#if filteredPlayers.length === 0}
  <h1>
    Select cards to
    <span class="favorite">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24px"
        height="24px">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5
          3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22
          8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
      </svg>
    </span>
    your favorite players!
  </h1>
{:else}
  <div class="card-grid">
    {#if (selfieCard && filter === 'ALL') || (selfieCard && filter === selfieCard.positionCode)}
      <PlayerCard {selfieCard} />
    {/if}
    {#each filteredPlayers as player, i (player.person.id)}
      <PlayerCard {player} />
    {/each}
  </div>
{/if}
